import { get } from 'lodash';

import Model from 'models';
import Money from 'utils/Money';
import { generateProductUrl, parseQueryString } from 'utils/Url';

const ShopifySearchProduct = class extends Model {
  get handle() {
    return get(this._data, 'handle');
  }

  get trackingParameters() {
    return get(this._data, ['trackingParameters']);
  }

  get url() {
    const trackingParametersObj = parseQueryString(this.trackingParameters);

    return generateProductUrl(this.handle, trackingParametersObj);
  }

  _compareAtPriceRangeMaxVariant() {
    return get(this._data, ['compareAtPriceRange', 'maxVariantPrice', 'amount']);
  }

  _compareAtPriceRangeMinVariant() {
    return get(this._data, ['compareAtPriceRange', 'minVariantPrice', 'amount']);
  }

  get compareAtPrice() {
    return this._compareAtPriceRangeMaxVariant();
  }

  get formattedCompareAtPrice() {
    return this.compareAtPrice > 0 ? new Money(this.compareAtPrice * 100).format() : null;
  }

  _priceRangeMaxVariant() {
    return get(this._data, ['priceRange', 'maxVariantPrice', 'amount']);
  }

  _priceRangeMinVariant() {
    return get(this._data, ['priceRange', 'minVariantPrice', 'amount']);
  }

  get price() {
    return this._priceRangeMaxVariant();
  }

  get formattedPrice() {
    return this.price > 0 ? new Money(this.price * 100).format() : null;
  }

  /**
   * Expected value to be like:
   *
   * [
        "allbirds::carbon-score => 4.52",
        "allbirds::cfId => color-mens-tree-skippers-kauri-marine-blue",
        ...
      ]
   */
  _getTagByKey(tagName) {
    const tags = get(this._data, 'tags') || [];
    const tagElement = tags?.find(itemTag => itemTag?.includes(tagName));
    const tagValue = tagElement?.split(' => ')[1];

    return tagValue;
  }

  get masterName() {
    return get(this._data, ['masterName', 'value']);
  }

  get colorName() {
    return get(this._data, ['colorName', 'value']);
  }

  get _imageSrc() {
    return get(this._data, ['featuredImage', 'url']);
  }

  get image() {
    return {
      alt: this.colorName,
      src: this._imageSrc,
    };
  }

  get sortedSizes() {
    return false; // not in the object right now
  }
};

export default ShopifySearchProduct;
